import React, { Component } from 'react';
import { Whitespace, Text, View } from '../../../components_new/common';
import { Separator } from '../../../components_new/Separator';
import Button from '../../../components_new/common/FormComponents/Button';
import { Link } from 'react-scroll';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import history from '../../../core/history';
import { trackClick } from '../../../core/analytics';

@observer
class HowItWorks extends Component {
  @observable owner = false;

  onClick = (path, text) => {
    trackClick('how-it-works', text);
    history.push(path);
  };

  render() {
    return (
      <div className="">
        <div className="collectively vh-90 bg-primaryLight f f-rows">
          <div className="f f-rows f-1">
            <div className="f f-1 f-sc">
              <div className="f f-columns ">
                <div className="f-4" />
                <div className="f f-rows f-6 mr-l f-between-end">
                  <View className="f-rows f-start-end">
                    <Text h1-x white textAlign="right" lineSpacing="58px">
                      RENT MORE,
                    </Text>
                    <Text h1-x white textAlign="right" lineSpacing="58px">
                      DO MORE.
                    </Text>
                  </View>
                  <Separator styles="bb-8 w-180 b-white" />
                  <Text noclip white t-lx textAlign="right">
                    That’s why there’s
                    <Text bold noclip white t-lx inline>
                      {' '}
                      Yoodlize, the rental platform for stuff!{' '}
                    </Text>
                    With Yoodlize, renting items to or from your community is safe, secure, and fun!
                  </Text>
                </div>
                <div className="f-6 ">
                  <iframe
                    src="https://player.vimeo.com/video/335912641"
                    width="640"
                    height="360"
                    frameBorder="0"
                    allow="autoplay; fullscreen"
                    allowFullscreen
                  />
                </div>
                <div className="f-4" />
              </div>
            </div>
            <div className="f-cc f-s-1 m-l">
              <Link to="how" smooth={true} duration={500}>
                <i className="fal fa-chevron-circle-down offWhite fa-4x pointer" />
              </Link>
            </div>
          </div>
        </div>
        <div className="how f f-rows f-start-center py-xl">
          <div>
            <Text grayDark t-xl>
              How Yoodlize Works
            </Text>
          </div>
          <div>
            <Text>Meet Yoodlize, the peer-to-peer rental platform for just about anything!</Text>
            <Text>Toggle between the “Renters” and “Owners” paths below to learn more.</Text>
          </div>
          <Whitespace />
          <div>
            <div className="f f-columns f-around-start mb-lxx">
              <Button primary muted={this.owner} action onClick={() => (this.owner = false)} mr={5}>
                Renters
              </Button>
              <Button secondary muted={!this.owner} action onClick={() => (this.owner = true)}>
                Owners
              </Button>
            </div>
          </div>
          <Whitespace />
          <div>
            <View if={!this.owner} className="g g-tc-a-4 g-g-xlx ">
              <HowItWorksItem
                icon="clipboard-list"
                num="1"
                name="Search"
                text1="Browse listings by"
                text2="keyword or category."
                owner={this.owner}
              />
              <HowItWorksItem
                icon="calendar-check"
                num="2"
                name="Reserve"
                text1="Select an item and the"
                text2="dates you'd like to use it."
                owner={this.owner}
              />
              <HowItWorksItem
                icon="snowboarding"
                num="3"
                name="Enjoy"
                text1="Pickup your rental item"
                text2="then have fun!"
                owner={this.owner}
              />
              <HowItWorksItem
                icon="repeat"
                num="4"
                name="Return"
                text1="Return the item to the"
                text2="owner then leave a review."
                owner={this.owner}
              />
            </View>
            <View if={this.owner} className="g g-tc-a-4 g-g-xlx ">
              <HowItWorksItem
                icon="plus-square"
                num="1"
                name="List"
                text1="Create listings for anything"
                text2="that you own."
                owner={this.owner}
              />
              <HowItWorksItem
                icon="comment-check"
                num="2"
                name="Approve"
                text1="Respond to and approve"
                text2="rental requests."
                owner={this.owner}
              />
              <HowItWorksItem
                icon="people-carry"
                num="3"
                name="Rent"
                text1="Rent out your things"
                text2="to people in your area."
                owner={this.owner}
              />
              <HowItWorksItem
                icon="usd-circle"
                num="4"
                name="Earn"
                text1="Make money every time"
                text2="your items are used"
                owner={this.owner}
              />
            </View>
          </div>
        </div>
        <div className="safe f f-rows f-between-center p-xl bg-offWhite">
          <Text grayDark t-xl>
            Why Yoodlize is safe and secure
          </Text>
          <Whitespace smaller />
          <div className="f f-rows f-cc">
            <Text>Keeping our users and their items safe secure on Yoodlize is one of our top</Text>
            <Text>priorities. Here are some of the steps we’ve taken to make it happen.</Text>
          </div>
          <Whitespace large />
          <div className="f f-cc">
            <div className="f-1" />
            <div className="g g-tc-a-3 g-g-l f-2">
              <div>
                <Text h4 primaryDark textAlign="right">
                  Identity Verification
                </Text>
                <Text noclip textAlign="right">
                  Our rigorous owner verification process uses email, credit card info, Facebook,
                  and other documentation.
                </Text>
                <Whitespace />
                <Text h4 primaryDark textAlign="right">
                  Rule Setting System
                </Text>
                <Text noclip textAlign="right">
                  Owners can protect their stuff by adding custom rules to their listings, including
                  requiring security deposits.
                </Text>
              </div>
              <div>
                <img src="/images/shield.svg" className="primaryDark h-180 w-160" />
              </div>
              <div>
                <Text h4 primaryDark>
                  User Support Team
                </Text>
                <Text noclip>
                  In the unlikely event your stuff is lost, damaged, or stolen, the Yoodlize support
                  team is on call.
                </Text>
                <Whitespace />
                <Text h4 primaryDark>
                  Item Protection
                </Text>
                <Text noclip>
                  Rent worry free: All items are automatically covered up to $2000 by our guarantee.
                </Text>
              </div>
            </div>
            <div className="f-1" />
          </div>
        </div>
        <div className="banner h-300 f f-columns">
          <div className="f f-1">
            <img
              src="images/education/table-saw-guy.jpg"
              alt="guy using saw"
              className="h-300 cover"
              style={{ objectPosition: '100% 50%' }}
            />
          </div>
          <div className="f f-1 f-columns h-300">
            <div className="bg-secondary f-1 p-xl f-rows f-center-start">
              <Text t-lxxx white semibold>
                u·ti·lize
              </Text>
              <Whitespace smaller2 />
              <Text h1-x pn white>
                / 'yoodl,iz /
              </Text>
              <Whitespace smaller2 />
              <div>
                <Text t-l white italic>
                  Verb
                </Text>
                <Text t-l white>
                  make practical and effective use of.
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="list f-cc p-xl">
          <div className="bg-offWhite brad-mx p-lxx f-rows f">
            <div>
              <Text h4 primary inline italic letterSpacing="1.2px">
                Yoodlize Team Tip:
              </Text>
              <Text inline t-lxx letterSpacing="1.2px">
                {' '}
                Frequently Searched Items
              </Text>
            </div>
            <Whitespace small />
            <div className="f f-cc">
              <Text t-s>
                Not sure what to list? Here are some high-demand items based on our user data:
              </Text>
            </div>
            <Whitespace small />

            <div className="f f-columns f-between-stretch">
              <div className="f f-cc f-rows">
                <Text>Power Drill</Text>
                <Whitespace smaller2 />
                <Text>Mountain Bike</Text>
                <Whitespace smaller2 />
                <Text>Wedding Dress</Text>
                <Whitespace smaller2 />
                <Text>Tent</Text>
                <Whitespace smaller2 />
                <Text>Outdoor Grill</Text>
              </div>
              <div className="b-0 br-1 b-coolGray w-1" />
              <div className="f f-cc f-rows">
                <Text>Hammer</Text>
                <Whitespace smaller2 />
                <Text>Weed Wacker</Text>
                <Whitespace smaller2 />
                <Text>Camera</Text>
                <Whitespace smaller2 />
                <Text>Drone</Text>
                <Whitespace smaller2 />
                <Text>Projector</Text>
              </div>
              <div className="b-0 br-1 b-coolGray w-1" />
              <div className="f f-cc f-rows">
                <Text>Canoe</Text>
                <Whitespace smaller2 />
                <Text>Decorations</Text>
                <Whitespace smaller2 />
                <Text>Longboard</Text>
                <Whitespace smaller2 />
                <Text>Tractor</Text>
                <Whitespace smaller2 />
                <Text>Bobcat</Text>
              </div>
              <div className="b-0 br-1 b-coolGray w-1" />
              <div className="f f-cc f-rows">
                <Text>Bounce House</Text>
                <Whitespace smaller2 />
                <Text>Kayak</Text>
                <Whitespace smaller2 />
                <Text>Costume</Text>
                <Whitespace smaller2 />
                <Text>Prom Dress</Text>
                <Whitespace smaller2 />
                <Text>Mask</Text>
              </div>
            </div>
            <Whitespace small />
            <div className="f-cc"></div>
          </div>
        </div>
        <div className="action bg-primaryLight f-cc f-rows f p-l h-300">
          <div>
            <img src="/images/logo/logo-light.svg" className="w-400 h-130" />
          </div>
          <Text white h3>
            What will you yoodlize?
          </Text>
          <Whitespace medium />
          <div className="f f-columns">
            <button
              className="ml-m b-1 b-white white bg-transparent h-36 brad-m px-l"
              onClick={() => this.onClick('/s', 'Browse Listings')}
            >
              Browse Listings
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default HowItWorks;

export function HowItWorksItem(props) {
  const { icon, num, name, text1, text2, owner, iconStyle } = props;
  const color = owner ? 'primary' : 'secondary';
  const iconS = iconStyle || 'fal';

  return (
    <div className="h-230 f-rows f-sc">
      <div className={`bg-${color} brad-full h-30 w-30 f f-cc pt-sxxx`}>
        <Text h3 white pn>
          {num}
        </Text>
      </div>
      <Whitespace large />
      <i className={`${iconS} fa-${icon} fa-5x`} />
      <Whitespace medium />
      <div className="f f-cc f-rows">
        <Text h4 primaryDark={owner} secondary={!owner}>
          {name}
        </Text>
        <Whitespace xsmall />
        <Text noclip t-l>
          {text1}
        </Text>
        <Text noclip t-l>
          {text2}
        </Text>
        <Whitespace smaller />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/static/how-it-works/HowItWorks.js